import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faCogs, faDesktop, faEnvelope, faShieldAlt, faWrench, faRobot, faKey, faUserMd, faNetworkWired, faHistory, faPills } from '@fortawesome/free-solid-svg-icons';
import '../styles/LandingPage.css';
import { useAuth } from '../hooks/useAuth';

const AdminLanding = () => {
  const { rolePermissions } = useAuth();

  function MyLink(props) { 
    if(rolePermissions[props.path]?.View === 'true') {
      return (
        <Link to={props.path} className="link-card">
          <FontAwesomeIcon icon={props.iconname} size="3x" className="icon"/>
          <p>{props.name}</p>
        </Link>
      );
    }
  }

  return (
    <div className="landing-page">
      <div className="links-container">
        <MyLink path="/user-management" iconname={faUser} name="User Management"/>
        <MyLink path="/role-management" iconname={faCogs} name="Role Management"/>
        <MyLink path="/mfa-settings" iconname={faShieldAlt} name="MFA Settings"/>
        <MyLink path="/job-monitor" iconname={faDesktop} name="OB Monitor"/>
        <MyLink path="/admin/messaging" iconname={faEnvelope} name="Messaging" />
        <MyLink path="/site-config" iconname={faWrench} name="Site Configuration" />
        <MyLink path="/network-access-config" iconname={faNetworkWired} name="Network Access" />
        <MyLink path="/ai-admin" iconname={faRobot} name="AI Admin" />
        <MyLink path="/api-key-management" iconname={faKey} name="API Keys" />
        <MyLink path="/doctor-management" iconname={faUserMd} name="Doctor Management" />
        <MyLink path="/medication-catalog" iconname={faPills} name="Medication Catalog" />
        <MyLink path="/audit-trail" iconname={faHistory} name="Audit Trail" />
      </div>
    </div>
  );
};

export default AdminLanding;
